import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";

import {
  getCustomerMasterlist,
  saveCustomerDetails,
  updateCustomerDetails,
} from "../../../../apiservicescall/api";

import Table from "@mui/material/Table";
import { Link } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Col, Badge, Card, Row, Button, Container } from "react-bootstrap";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { Form, FormGroup, Label, Input } from "reactstrap";
import swal from "sweetalert";
// import { faXmark } from '@fortawesome/pro-solid-svg-icons';

const Template_list = () => {
  const [customerList, setCustomerList] = useState([
    {
      firstName: "muthu",
      custMobile: "8978455612",
      emailId: "Thanks for order",
    },
    {
      firstName: "rajsejkar",
      custMobile: "8978455612",
      emailId: "Received your feedback",
    },
    {
      firstName: "vijay",
      custMobile: "8978455612",
      emailId: "Food Offers for you",
    },
  ]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getcustomerlist();
  }, []);

  const getcustomerlist = async () => {
    let customerList = await getCustomerMasterlist();

    let customerlistvalue = customerList?.data.data || [];
    // setCustomerList(customerlistvalue);

    let totpage = Math.ceil(customerlistvalue.length / itemsPerPage);

    setTotalPages(totpage);

    let titem = customerlistvalue.length;
    setTotalItems(titem);
  };

  const opnAddNewUserModal = (e) => {
    //e.preventDefault();
    // setLargeModal(!largeModal);
    // setIsview(false);
    // setIsedit(false);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const options = {
    filter: false,
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    filterType: "dropdown",
    selectableRows: false,
    responsive: "stacked",
    // count: totalItems,
    search: false,
    // textLabels: {
    // 	body: {
    // 		noMatch: labelmessage
    // 	},
    // },
    fixedHeader: true,
    tableBodyHeight: "425px",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    // onColumnSortChange: this.customSort,
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },

    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterVal,
      filterOptions,
      changedColumnIndex,
      displayData
    ) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        this.handleFilterSubmit(newFilters);
      }
    },

    onSearchChange: (searchValue) => this.customSearch(searchValue),
    // table's internal filterList
    confirmFilters: true,

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => this.handleFilterSubmit(applyNewFilters)}
          >
            Apply Filters
          </Button>
        </div>
      );
    },

    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {},

    onFilterDialogOpen: () => {},
    onFilterDialogClose: () => {},
    customToolbar: () => {
      return (
        <>
          {
            <>
              <Link
                to={`/TemplateService`}
                className="caret btn-sm mr-10"
                style={{
                  backgroundColor: "#008000",
                  color: "white",
                  width: "10px",
                  height: "20px",
                }}
              >
                Create Template <i className="zmdi zmdi-lus"> </i>{" "}
              </Link>
              {/* ) : (
                  <a
                    href="#"
                    style={{
                      backgroundColor: "#008000",
                      color: "white",
                      fontSize: "medium",
                    }}
                    onClick={(e) => {
                      opnAddNewUserModal(e);
                      setCustomerDetail({});
                    }}
                    className="caret btn-sm mr-10"
                  >
                    Add <i className="zmdi zmdi-lus"></i>
                  </a>
                )} */}
            </>
          }
        </>
      );
    },
    //Search Query for list

    // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
    //
    //   return (
    // 	<>
    // 	  <CustomSearchRender
    // 		debounceWait={500}
    // 		searchText={searchText}
    // 		onSearch={this.handleSearch}
    // 		onHide={hideSearch}
    // 		options={options}
    // 		onClear={this.handleClear}
    // 		searchField={this.state.searchField}
    // 		searchValue={this.state.searchValue}
    // 		fields={this.state.fields}
    // 		handleFieldChange={this.handleFieldChange}
    // 	  />
    // 	</>
    //   );
    // },
  };

  const columns = [
    // {
    //   name: "firstName",
    //   label: "Name",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",
    //   },
    // },

    // {
    //   name: "custMobile",
    //   label: "Mobile NO",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     customFilterListOptions: { render: (v) => `UID: ${v}` },
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",
    //   },
    // },

    {
      name: "emailId",
      label: "Template Message",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "Reply",
      label: "Message Reply",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (summary, tableMeta, updateValue) => {
          return (
            <div className="list-action">
              <span style={{ color: "black" }} className="icon-top-left">
                <Link
                  className="btn btn-primary shadow btn-xs sharp me-2"
                  onClick={() => {
                    // onEditUser(tableMeta);
                  }}
                  style={{ background: "#008000" }}
                >
                  <i className="fas fa-pencil-alt fa-lg"></i>
                </Link>
              </span>
            </div>
          );
        },
      },
    },
  ];

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  const getSteps = () => {
    return ["Channel", "Campaign Mode", "Target", "Content", "Schedule"];
  };

  const totalSteps = () => {
    return this.getSteps().length;
  };

  return (
    <RctCollapsibleCard fullBlock>
      <MuiThemeProvider theme={themeTable}>
        {customerList && (
          <MUIDataTable
            title={"Template List"}
            data={customerList}
            columns={columns}
            options={options}
            columOrder={columns}
          />
        )}
      </MuiThemeProvider>
    </RctCollapsibleCard>
  );
};

export default Template_list;
